import React, { useRef } from "react";
import { Modal } from "@shopify/polaris";
import { useMutation } from "@apollo/react-hooks";

import { REMOVE_PRODUCT_CANNOT_CONFIG_IN_PB } from "../../../graphql/mutations";
import { handleError } from "../../../helper";
import { useToastContext } from "../../shared/ToastContext";

export const RemoveMarkPBError = ({
    open,
    toggleShowModal,
    onNotificationChange,
    refetch,
    toggleActive,
    product,
}) => {
    const productId = product?.id;

    // Ref
    const onCloseRef = useRef(null);

    // Context
    const { setFilter } = useToastContext();

    // Mutation
    const [removeMarkPBError, { loading }] = useMutation(
        REMOVE_PRODUCT_CANNOT_CONFIG_IN_PB,
        {
            onError: (error) => {
                if (onNotificationChange) {
                    onNotificationChange({
                        message: handleError(error.toString()),
                        isError: true,
                    });
                }
            },
            onCompleted: () => {
                toggleShowModal();
                if (onNotificationChange) {
                    onNotificationChange({
                        message: `Remove mark Facebook error successfully.`,
                        isError: false,
                    });
                }
                // onClose parent modal
                onCloseRef.current && clearTimeout(onCloseRef.current);
                onCloseRef.current = setTimeout(() => {
                    setFilter && setFilter((prev) => ({ ...prev }));
                    refetch && refetch();
                }, 1000);
            },
        }
    );

    // Handle actions
    const handleSubmit = React.useCallback(() => {
        if (productId) {
            if (toggleActive) {
                toggleActive();
            }
            if (onNotificationChange) {
                onNotificationChange({
                    message: null,
                    isError: false,
                });
            }
            removeMarkPBError({
                variables: {
                    productId,
                },
            });
        }
    }, [productId, removeMarkPBError, toggleActive, onNotificationChange]);

    return (
        <Modal
            title="Remove Mark Facebook Error"
            open={open}
            onClose={toggleShowModal}
            sectioned
            secondaryActions={[
                { content: "Cancel", onAction: toggleShowModal },
            ]}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <p>Are you sure to remove mark Facebook error?</p>
        </Modal>
    );
};
